import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../main/ExportHeader";
import Nav from "../main/nav";
import Footer from "../main/footer";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime } from "../main/formatToDateTime";
import DateRange from "../main/DateRange";

export default function ExportJobs() {
  const [Data, setData] = useState([]);
  const [Jobs, setJobs] = useState("");
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [job_type, setJobType] = useState("");
  const [jobTypeFilter, setJobTypeFilter] = useState("1");
  const [FclLcl, setFclLcl] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  useEffect(() => {
    GetData();
  }, [jobTypeFilter, , FclLcl, start, end, job_type,date]);

  const GetData = async (page = 1) => {
    setLoading(true);

    let url = `https://ctas.live/backend/api/warehouse/jobs?warehouse=Export&page=${page}`;
    if (job_type) {
      url += `&job_type=${job_type}`;
    }
    if (jobTypeFilter) {
      url += `&status=${jobTypeFilter}`;
    }
    if (FclLcl) {
      url += `&flc_lcl_flg=${FclLcl}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    if (date) {
      url += `&date=${date}`;
    }

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
        setJobs(response.data.jobs);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFromSubmit = (e) => {
    e.preventDefault();
    let range = e.target.range.value;
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
    setFclLcl(e.target.lcl_flc.value);
    setJobType(e.target.job_type.value);
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="sk-chase-dot" />
            ))}
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div className="card">
                      <div className="card-body row">
                        <div className="d-flex flex-row-reverse">
                          <div className="">
                            <label htmlFor="">Sort By Date</label>
                            <input
                              type="date"
                              className="form-control p-1"
                              defaultValue={Jobs.date}
                              id="myDate"
                              onChange={(e) => {
                                setDate(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 mb-2">
                          <div className="table-responsive">
                            <p className="text-center text-primary m-0">
                              SJO Jobs
                            </p>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Previous Days Pending</th>
                                  <th>No. of SJO Generated</th>
                                  <th>Shifted</th>
                                  <th>Total Pending</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{Jobs?.sjo?.pre_pending ?? 0}</td>
                                  <td>{Jobs?.sjo?.total ?? 0}</td>
                                  <td>{Jobs?.sjo?.completed ?? 0}</td>
                                  <td>
                                    {Jobs?.sjo?.pending +
                                      Jobs?.sjo?.pre_pending ?? 0}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-lg-6 mb-2">
                          <div className="table-responsive">
                            <p className="text-center text-primary m-0">
                              Sealed Jobs
                            </p>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Previous Days Pending</th>
                                  <th>No. of WSL Generated</th>
                                  <th>Shifted</th>
                                  <th>Total Pending</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{Jobs?.sealed?.pre_pending ?? 0}</td>
                                  <td>{Jobs?.sealed?.total ?? 0}</td>
                                  <td>{Jobs?.sealed?.completed ?? 0}</td>
                                  <td>
                                    {Jobs?.sealed?.pending +
                                      Jobs?.sealed?.pre_pending ?? 0}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="com-md-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="btn-group mb-3" role="group">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              jobTypeFilter == "1"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setJobTypeFilter("1")}
                          >
                            Job In Queue
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              jobTypeFilter == "2"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setJobTypeFilter("2")}
                          >
                            Completed
                          </button>
                        </div>
                        <form
                          className="needs-validation"
                          noValidate=""
                          onSubmit={handleFromSubmit}
                        >
                          <div className="row">
                            <div className="col-md-5">
                              <div className="form-floating form-floating-outline">
                                <DateRange />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <select name="lcl_flc" className="form-select">
                                  <option value="">All</option>
                                  <option value="FCL">FCL</option>
                                  <option value="LCL">LCL</option>
                                </select>
                                <label className="form-label" htmlFor="lcl_flc">
                                  FCL/LCL
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <select name="job_type" className="form-select">
                                  <option value="">All</option>
                                  <option value="SJO">SJO</option>
                                  <option value="Sealed">Sealed</option>
                                </select>
                                <label
                                  className="form-label"
                                  htmlFor="job_type"
                                >
                                  Job Type
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <button
                                type="submit"
                                className="btn btn-label-primary waves-effect waves-light me-1"
                              >
                                <i className="ri-arrow-right-line ri-20px" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-label-primary waves-effect waves-light me-1"
                                onClick={() => window.location.reload()}
                              >
                                <i className="ri-restart-line ri-20px" />
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <th>S.No.</th>
                              <th>Job Type</th>
                              <th>CTR No</th>
                              <th>CTR Size</th>
                              <th>CTR Type</th>
                              <th>Loaded/Empty</th>
                              <th>FCL/LCL</th>
                              <th>Source</th>
                              <th>Generate</th>
                              {jobTypeFilter == "2" && (
                                <th>JOB Compliance Date</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.data?.map((data, key) => (
                              <tr key={data.rn}>
                                <td>{data.rn}</td>
                                <td>{data.job_type}</td>
                                <td>{data.container_no}</td>
                                <td>{data.container_size}</td>
                                <td>{data.container_type}</td>
                                <td>
                                  {data?.ldd_mt_flg === "L"
                                    ? "Loaded"
                                    : "Empty"}
                                </td>
                                <td>{data?.flc_lcl_flg}</td>
                                <td>{data?.icd_location?.replace("*", "")}</td>
                                <td>{formatToDateTime(data?.created_at)}</td>
                                {jobTypeFilter == "2" && (
                                  <td>
                                    {data?.yard_tran?.created_at
                                      ? formatToDateTime(
                                          data?.yard_tran?.created_at
                                        )
                                      : ""}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data.links.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
